export async function klaviyoSubscribe(
  listId: string,
  emailAddress: string,
  { customSource, ...optionalTraits }: Record<string, string> = {}
) {
  const PUBLIC_API_KEY = window.theme?.klaviyo?.companyId ?? "";

  return fetch(
    `https://a.klaviyo.com/client/subscriptions/?company_id=${PUBLIC_API_KEY}`,
    {
      method: "POST",
      headers: {
        revision: "2024-05-15",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source: customSource,
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: emailAddress,
                  properties: {
                    market: window.theme?.customer?.market,
                  },
                  ...optionalTraits,
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: listId,
              },
            },
          },
        },
      }),
    }
  ).catch((err) => console.error(err));
}
